var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M31.33 8.25A4.02 4.02 0 0 0 28.5 5.4C26 4.73 16 4.73 16 4.73s-10 0-12.5.67A4.02 4.02 0 0 0 .67 8.25 42.18 42.18 0 0 0 0 16a42.18 42.18 0 0 0 .67 7.75A4.02 4.02 0 0 0 3.5 26.6c2.5.67 12.5.67 12.5.67s10 0 12.5-.67a4.02 4.02 0 0 0 2.83-2.85A42.18 42.18 0 0 0 32 16a42.18 42.18 0 0 0-.67-7.75zm-18.6 12.5v-9.5L21.09 16z"}));
}

Youtube.defaultProps = {"viewBox":"0 0 32 32","fillRule":"evenodd","id":"ki-youtube-f"};

module.exports = Youtube;

Youtube.default = Youtube;
